module.exports = __webpack_public_path__ + "static/img/s401.64df13d.png";


//////////////////
// WEBPACK FOOTER
// ./src/module/productSpring/images/s401.png
// module id = 553
// module chunks = 3